import { useEffect, useRef } from "react";

const quitUnityRuntime = instance => {
  if (!instance || typeof instance.Quit !== "function") {
    return Promise.resolve();
  }

  return Promise.resolve(instance.Quit()).catch(() => undefined);
};

const clearGlobalUnityInstance = instance => {
  if (typeof window === "undefined") return;
  if (window.unityInstance === instance) {
    window.unityInstance = null;
  }
};

export const useQuitUnityOnUnmount = unityInstance => {
  const unityInstanceRef = useRef(null);
  const cancelledRef = useRef(false);

  useEffect(() => {
    cancelledRef.current = false;

    return () => {
      cancelledRef.current = true;
      const instance = unityInstanceRef.current;
      unityInstanceRef.current = null;
      clearGlobalUnityInstance(instance);
      quitUnityRuntime(instance);
    };
  }, []);

  useEffect(() => {
    if (!unityInstance) return;

    if (cancelledRef.current) {
      clearGlobalUnityInstance(unityInstance);
      quitUnityRuntime(unityInstance);
      return;
    }

    unityInstanceRef.current = unityInstance;
  }, [unityInstance]);
};
